module.exports = __webpack_public_path__ + "img/product.0a465c8d.png";